//SCSS
require("view/header/Header.scss");

//BASE
const UIComponent = require("base/UIComponent");

//UTILS:
const _Event = require("util/Event");
const _Misc = require("util/Misc");
const _FireAuth = require("util/FireAuth");

//HTMLS:
const HTML = require("view/header/Header.html");

class Header extends UIComponent {
    constructor() {
        super("#main", HTML, true);
    };

    initialize(){
        super.initialize(false);
    };

    createChildren(){
        super.createChildren();
    };

    addEventListeners(){
        super.addEventListeners();
        this.bodyFn = this.onMenuTap.bind(this);
        this.betaBodyTap = this.onBodyTap.bind(this);
        _Event.tap(".header-menu", this.bodyFn, this.$self);
        _Event.tap(".beta", this.onBetaTap.bind(this), this.$self);
    };

    initialized(){
        super.initialized();
    };

    onMenuTap(){
        if(Header.busy)
            return;
        this.busy = true;
        let $linkWrapper = $(".link-wrapper", this.$self);
        let isOpen = $linkWrapper.hasClass("active");
        let cls = (isOpen) ? "fadeOutUp" : "active fadeInDown";
        $linkWrapper.addClass(cls);
        _Misc.callLater(function(){
            this.busy = false;
            cls = (isOpen) ? "active fadeOutUp" : "fadeInDown";
            $linkWrapper.removeClass(cls);
            _Event.bodyTap(this.bodyFn, isOpen);
        }.bind(this),250);
    };

    pathChanged(l1, l2, l3){
        let $linkWrapper = $(".link-wrapper", this.$self);
        let $a = $("a[href='/" + l1 + "']", $linkWrapper);
        let $as = $("a", $linkWrapper);
        $as.removeClass("active");
        $a.addClass("active");
    };

    onBetaTap(){
        _Misc.setOverlay(true, false);
        $("#betaInfo").css("display", "flex");
        _Event.bodyTap(this.betaBodyTap);
    };

    onBodyTap(){
        _Misc.setOverlay(false, false);
        $("#betaInfo").css("display", "none");
        _Event.bodyTap(this.betaBodyTap, true);
    }
}

module.exports = Header;



// WEBPACK FOOTER //
// ./src/view/header/Header.js